import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
import { MatchingAnswer } from './matching-answer';
export var MatchingAnswerGroup = /*#__PURE__*/function (_ValueObject) {
  _inherits(MatchingAnswerGroup, _ValueObject);

  var _super = _createSuper(MatchingAnswerGroup);

  function MatchingAnswerGroup() {
    _classCallCheck(this, MatchingAnswerGroup);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingAnswerGroup, [{
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "questionId",
    get: function get() {
      return this.props.questionId;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "score",
    get: function get() {
      return this.answers.reduce(function (total, answer) {
        if (answer.hasGraded()) {
          return total + answer.score;
        }

        return total;
      }, 0);
    }
  }, {
    key: "hasGraded",
    value: function hasGraded() {
      return this.answers.every(function (answer) {
        return answer.hasGraded();
      });
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answer) {
      this.props.answers.splice(this.props.answers.indexOf(answer), 1, answer);
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return this.answers.every(function (answer) {
        return answer.isSkipped();
      });
    }
  }, {
    key: "updateComment",
    value: function updateComment(comment) {
      this.props.comment = comment;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var collection = [{
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.questionId,
        argumentName: 'Question Id'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.answers,
        argumentName: 'Answers'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok(new MatchingAnswerGroup(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            sectionId = data.sectionId,
            questionId = data.questionId,
            type = data.type;
        var answerProps = answers.map(function (answer) {
          var answerOrError = MatchingAnswer.fromJson({
            subQuestionId: answer.subQuestionId || answer.props.subQuestionId,
            value: answer.value,
            id: answer.id || answer.props.id,
            sectionId: sectionId,
            questionId: questionId,
            type: type,
            score: answer.score
          });

          if (answerOrError.isFailure) {
            return Result.fail(answerOrError.error);
          }

          return answerOrError.getValue();
        });
        return this.create(_objectSpread(_objectSpread({}, data), {}, {
          answers: answerProps
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MatchingAnswerGroup;
}(ValueObject);